<template>
  <div>
    <div class="bg-icon__wrapper">
      <svg
        class="bg-icon"
        width="699px"
        height="699px"
        viewBox="0 0 699 699"
        fill="none"
      >
        <path
          d="M698.383 241.704H457.266V0.587463L241.705 0.587463V241.704H0.587402L0.587402 457.267H241.705V698.384H457.266L457.266 457.267L698.383 457.267V241.704Z"
          fill="#303AB2"
          fill-opacity="0.05"
        />
      </svg>
    </div>
    <div class="flex">
      <MyAccountWrapper />
      <div class="profile">
        <div class="profile__content relative flex items-center justify-center">
          <div class="profile__profileWrapper">
            <div class="flex flex-col items-center justify-center gap-5">
              <p class="profile-title dark:text-secondary-100">
                {{ $t("settings.password.subtitle") }}
              </p>
              <p
                class="text-sm font-medium w-full text-left dark:text-greyscale-500"
              >
                {{ $t("settings.password.description") }}
              </p>
            </div>
            <div class="profile__inputs">
              <div class="profile__row">
                <div class="profile__column">
                  <Input
                    @enter="enter"
                    id="password"
                    v-model="form.password"
                    :type="inputTypeIconPassword"
                    :placeholder="$t('input.password.current')"
                    :error="$v.form.password.$anyError"
                    tabindex="2"
                    :darkModeClass="true"
                  >
                    <button
                      class="toggleButtonIcon"
                      @click.prevent="ToggleButtonIconPassword"
                      tabindex="3"
                      :class="{ 'icon-error': $v.form.password.$anyError }"
                    >
                      <svg
                        v-if="inputTypeIconPassword == 'password'"
                        width="22"
                        height="16"
                        viewBox="0 0 22 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11 9.99988C12.1046 9.99988 13 9.10445 13 7.99988C13 6.89531 12.1046 5.99988 11 5.99988C9.89543 5.99988 9 6.89531 9 7.99988C9 9.10445 9.89543 9.99988 11 9.99988Z"
                          stroke="#718096"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M21 7.99988C18.333 12.6669 15 14.9999 11 14.9999C7 14.9999 3.667 12.6669 1 7.99988C3.667 3.33288 7 0.999878 11 0.999878C15 0.999878 18.333 3.33288 21 7.99988Z"
                          stroke="#718096"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <svg
                        v-else
                        width="25"
                        height="24"
                        viewBox="0 0 25 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.5 3L21.5 21"
                          stroke="#718096"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M11.0845 10.587C10.7092 10.9621 10.4982 11.4708 10.498 12.0013C10.4979 12.5319 10.7084 13.0408 11.0835 13.416C11.4585 13.7913 11.9672 14.0023 12.4977 14.0024C13.0283 14.0026 13.5372 13.7921 13.9125 13.417"
                          stroke="#718096"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M9.863 5.36506C10.7204 5.11978 11.6082 4.9969 12.5 5.00006C16.5 5.00006 19.833 7.33306 22.5 12.0001C21.722 13.3611 20.888 14.5241 19.997 15.4881M17.857 17.3491C16.226 18.4491 14.442 19.0001 12.5 19.0001C8.5 19.0001 5.167 16.6671 2.5 12.0001C3.869 9.60506 5.413 7.82506 7.132 6.65906"
                          stroke="#718096"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg></button
                  ></Input>
                </div>
                <span class="error mt-[10px]" v-if="passwordLengthControl">
                  The current password cannot be left blank
                </span>
              </div>
              <div class="profile__row">
                <div
                  class="profile__column"
                  @focusin="onFocus"
                  @focusout="onBlur"
                >
                  <Input
                    @enter="enter"
                    id="NewPassword"
                    v-model="form.NewPassword"
                    :type="inputTypeIconNewPassword"
                    :placeholder="$t('input.password.new')"
                    :error="$v.form.NewPassword.$anyError"
                    tabindex="2"
                    :darkModeClass="true"
                  >
                    <button
                      class="toggleButtonIcon"
                      @click.prevent="ToggleButtonIconNewPassword"
                      tabindex="3"
                      :class="{ 'icon-error': $v.form.NewPassword.$anyError }"
                    >
                      <svg
                        v-if="inputTypeIconNewPassword == 'password'"
                        width="22"
                        height="16"
                        viewBox="0 0 22 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11 9.99988C12.1046 9.99988 13 9.10445 13 7.99988C13 6.89531 12.1046 5.99988 11 5.99988C9.89543 5.99988 9 6.89531 9 7.99988C9 9.10445 9.89543 9.99988 11 9.99988Z"
                          stroke="#718096"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M21 7.99988C18.333 12.6669 15 14.9999 11 14.9999C7 14.9999 3.667 12.6669 1 7.99988C3.667 3.33288 7 0.999878 11 0.999878C15 0.999878 18.333 3.33288 21 7.99988Z"
                          stroke="#718096"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <svg
                        v-else
                        width="25"
                        height="24"
                        viewBox="0 0 25 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.5 3L21.5 21"
                          stroke="#718096"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M11.0845 10.587C10.7092 10.9621 10.4982 11.4708 10.498 12.0013C10.4979 12.5319 10.7084 13.0408 11.0835 13.416C11.4585 13.7913 11.9672 14.0023 12.4977 14.0024C13.0283 14.0026 13.5372 13.7921 13.9125 13.417"
                          stroke="#718096"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M9.863 5.36506C10.7204 5.11978 11.6082 4.9969 12.5 5.00006C16.5 5.00006 19.833 7.33306 22.5 12.0001C21.722 13.3611 20.888 14.5241 19.997 15.4881M17.857 17.3491C16.226 18.4491 14.442 19.0001 12.5 19.0001C8.5 19.0001 5.167 16.6671 2.5 12.0001C3.869 9.60506 5.413 7.82506 7.132 6.65906"
                          stroke="#718096"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </Input>
                  <PasswordValidationPopup
                    :password="this.form.NewPassword"
                    v-show="focused"
                    class="validation-popup-input"
                    :darkModeClass="true"
                  />
                </div>
                <span class="error mt-[10px]" v-if="newPasswordLengthControl">
                  The new password cannot be left blank
                </span>
                <span
                  class="error mt-[10px]"
                  v-if="
                    $v.form.NewPassword.$anyError && !newPasswordLengthControl
                  "
                  >The password you entered does not meet the required
                  criteria.</span
                >
              </div>
              <div class="profile__row">
                <div class="profile__column">
                  <Input
                    id="confirmPassword"
                    v-model="form.NewPasswordCheck"
                    :type="inputTypeConfirmPassword"
                    :placeholder="$t('input.password.new_again')"
                    :error="$v.form.NewPasswordCheck.$anyError"
                    tabindex="2"
                    :darkModeClass="true"
                  >
                    <button
                      class="toggleButtonIcon"
                      @click.prevent="ToggleButtonIconConfirmPassword"
                      tabindex="3"
                      :class="{
                        'icon-error': $v.form.NewPasswordCheck.$anyError,
                      }"
                    >
                      <svg
                        v-if="inputTypeConfirmPassword == 'password'"
                        width="22"
                        height="16"
                        viewBox="0 0 22 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11 9.99988C12.1046 9.99988 13 9.10445 13 7.99988C13 6.89531 12.1046 5.99988 11 5.99988C9.89543 5.99988 9 6.89531 9 7.99988C9 9.10445 9.89543 9.99988 11 9.99988Z"
                          stroke="#718096"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M21 7.99988C18.333 12.6669 15 14.9999 11 14.9999C7 14.9999 3.667 12.6669 1 7.99988C3.667 3.33288 7 0.999878 11 0.999878C15 0.999878 18.333 3.33288 21 7.99988Z"
                          stroke="#718096"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <svg
                        v-else
                        width="25"
                        height="24"
                        viewBox="0 0 25 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.5 3L21.5 21"
                          stroke="#718096"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M11.0845 10.587C10.7092 10.9621 10.4982 11.4708 10.498 12.0013C10.4979 12.5319 10.7084 13.0408 11.0835 13.416C11.4585 13.7913 11.9672 14.0023 12.4977 14.0024C13.0283 14.0026 13.5372 13.7921 13.9125 13.417"
                          stroke="#718096"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M9.863 5.36506C10.7204 5.11978 11.6082 4.9969 12.5 5.00006C16.5 5.00006 19.833 7.33306 22.5 12.0001C21.722 13.3611 20.888 14.5241 19.997 15.4881M17.857 17.3491C16.226 18.4491 14.442 19.0001 12.5 19.0001C8.5 19.0001 5.167 16.6671 2.5 12.0001C3.869 9.60506 5.413 7.82506 7.132 6.65906"
                          stroke="#718096"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </Input>
                </div>
                <span
                  v-if="newPasswordChecklengthControl"
                  class="error mt-[10px]"
                >
                  The confirm password cannot be left blank
                </span>
                <span
                  class="error mt-[10px]"
                  v-if="
                    $v.form.NewPasswordCheck.$anyError &&
                    !newPasswordChecklengthControl
                  "
                  >Please make sure that both password fields contain the same
                  password.</span
                >
              </div>
            </div>
            <div v-if="errors.length" class="profile__row">
              <div class="flex flex-col items-start">
                <ul>
                  <li :key="error" v-for="error in errors">
                    <span class="error">{{ error }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="profile__row">
              <div class="profile__column w-full">
                <Button
                  @click="enter()"
                  :disabled="isDisabled"
                  class="primary large w-full text-base font-extrabold"
                  >{{ $t("button.password.change") }}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyAccountWrapper from "@/components/MyAccountWrapper";
import Input from "@/components/Input";
import Button from "@/components/Button";
import {
  required,
  sameAs,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import PasswordValidationPopup from "@/components/PasswordValidationPopup";
import { helpers } from "vuelidate/lib/validators";

const passwordControl = helpers.regex(
  "passwordControl",
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*\-.\\]).{8,18}$/
);

export default {
  components: {
    Input,
    Button,
    MyAccountWrapper,
    PasswordValidationPopup,
  },
  data() {
    return {
      form: {
        password: "",
        NewPassword: "",
        NewPasswordCheck: "",
      },
      uploadImageModalIsOpen: false,
      modalIsOpen: false,
      errors: [],
      error: "",
      inputTypeIconPassword: "password",
      inputTypeIconNewPassword: "password",
      inputTypeConfirmPassword: "password",
      focused: false,
      passwordLengthControl: false,
      newPasswordLengthControl: false,
      newPasswordChecklengthControl: false,
      isDisabled: false,
    };
  },
  methods: {
    ...mapActions(["changePassword", "emitNotification", "initAuth"]),
    async updatePassword() {
      this.errors = [];
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      this.isDisabled = true;
      await this.changePassword({
        password: this.form.password,
        NewPassword: this.form.NewPassword,
        NewPasswordCheck: this.form.NewPasswordCheck,
      })
        .then(() => {
          this.emitNotification({
            type: "success",
            text: this.$t("notification.password.success_update"),
          });
          this.initAuth();
        })
        .catch((err) => {
          this.errors.push(err.response.data.message);
        })
        .finally(() => {
          this.isDisabled = false;
        });
    },
    enter() {
      this.updatePassword();
      if (!this.form.NewPasswordCheck.length) {
        this.newPasswordChecklengthControl = true;
      }
      if (!this.form.NewPassword.length) {
        this.newPasswordLengthControl = true;
      }
      if (!this.form.password.length) {
        this.passwordLengthControl = true;
      }
    },
    onFocus() {
      this.focused = true;
    },
    onBlur() {
      this.focused = false;
    },
    ToggleButtonIconPassword() {
      this.inputTypeIconPassword =
        this.inputTypeIconPassword === "password" ? "text" : "password";
    },
    ToggleButtonIconNewPassword() {
      this.inputTypeIconNewPassword =
        this.inputTypeIconNewPassword === "password" ? "text" : "password";
    },
    ToggleButtonIconConfirmPassword() {
      this.inputTypeConfirmPassword =
        this.inputTypeConfirmPassword === "password" ? "text" : "password";
    },
  },
  watch: {
    "form.password": {
      handler() {
        this.passwordLengthControl = !this.form.password.length;
      },
    },
    "form.NewPassword": {
      handler() {
        this.newPasswordLengthControl = !this.form.NewPassword.length;
      },
    },
    "form.NewPasswordCheck": {
      handler() {
        this.newPasswordChecklengthControl = !this.form.NewPasswordCheck.length;
      },
    },
  },
  validations: {
    form: {
      password: {
        required,
      },
      NewPassword: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(18),
        passwordControl,
      },
      NewPasswordCheck: {
        required,
        sameAsPassword: sameAs("NewPassword"),
      },
    },
  },
};
</script>
<style>
@import "index.module.css";
.icon-error svg path {
  @apply stroke-[#FF4747];
}
</style>
